var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCameraOffi = function SvgCameraOffi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z",
    "data-name": "Rectangle 1598"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M4.238 18.762a.843.843 0 0 1 0-1.174l12.173-12.35A.84.84 0 0 1 16.988 5a.84.84 0 0 1 .576.238.843.843 0 0 1 0 1.174L5.391 18.762a.84.84 0 0 1-.577.24.84.84 0 0 1-.576-.24m4.3-1.559 1.6-1.6h4.26v-1.08a1.8 1.8 0 0 1 .551-1.295 1.8 1.8 0 0 1 1.247-.51 1.8 1.8 0 0 1 .8.193l1.4.7v-2.82l-1.4.7a1.74 1.74 0 0 1-.8.191 1.72 1.72 0 0 1-1.418-.721l1.221-1.217v.141a.2.2 0 0 0 .2.2.3.3 0 0 0 .094-.021l2.26-1.137a1 1 0 0 1 .447-.1 1 1 0 0 1 1 1v4.76a1 1 0 0 1-1 1 1 1 0 0 1-.447-.1l-2.26-1.139a.3.3 0 0 0-.094-.02.21.21 0 0 0-.2.2v1.678a1.006 1.006 0 0 1-1 1zM5.8 7.803a1 1 0 0 1 1-1h6.458l-1.6 1.6h-4.26v4.26l-1.6 1.6z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCameraOffi);
export default ForwardRef;